import { Component } from 'preact'

export default class Focusable extends Component {
  render({ children, onClick, ...restProps }) {
    return (
      <div
        tabIndex="-1"
        onClick={onClick}
        onFocus={this.handleFocus}
        onBlur={this.handleBlur}
        {...restProps}
      >
        {children}
      </div>
    )
  }
}
